export type EncodedRequestBody = {
  encoding: 'base64json-v1';
  payload: string;
};

export function encodeRequestBody(value: unknown): EncodedRequestBody {
  const bytes = new TextEncoder().encode(JSON.stringify(value));
  let binary = '';
  for (const byte of bytes) binary += String.fromCharCode(byte);
  return { encoding: 'base64json-v1', payload: btoa(binary) };
}
